import { createRoute, redirect } from '@tanstack/react-router'

import { PERMISSIONS } from '@forto-dev/auth-sdk-models'

import { getPermissionsFromToken, hasPermission } from '@/features/auth'
import { rootRoute } from '@/routes/root'
import { getCurrentToken } from '@/utils/auth'
import { ensureAuthenticatedUser } from '@/utils/auth-wall'

export const companyDocumentsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/company/documents',
  beforeLoad: async ({ context, location }) => {
    await ensureAuthenticatedUser({ context, location })
    if (context.isReady && !context.isCustomerActive) {
      throw redirect({
        to: '/',
      })
    }
    if (!hasPermission(getPermissionsFromToken(getCurrentToken()), PERMISSIONS.DOCUMENTS.CUSTOMERS.READ)) {
      throw redirect({ to: '/' })
    }
  },
}).lazy(() => import('./documents/documents').then((d) => d.Route))
